import { getListFromApiResponse } from "@/Pages/Issues/issueMappers";

/**
 * Prefer row `projectId`; else resolve UUID from projects API payload when URL uses slug/key; else `projectSlug`.
 *
 * @param {string | undefined} projectSlug
 * @param {object | undefined} issue
 * @param {unknown} projectsDataOrList — Redux `projectsData` or a list array
 */
export function resolveProjectIdForWorkItemFetch(projectSlug, issue, projectsDataOrList) {
  const fromRow = issue?.projectId ?? issue?.project_id;
  if (fromRow != null && String(fromRow).trim() !== "") {
    return String(fromRow).trim();
  }
  const slug = projectSlug != null ? String(projectSlug).trim() : "";
  if (!slug) return "";
  const list = getListFromApiResponse(projectsDataOrList);
  const slugLower = slug.toLowerCase();
  const byId = list.find((p) => String(p?.id ?? p?.projectId ?? "") === slug);
  if (byId?.id != null && String(byId.id).trim() !== "") return String(byId.id).trim();
  const byKey = list.find(
    (p) =>
      String(p?.projectKey ?? p?.key ?? "")
        .trim()
        .toLowerCase() === slugLower
  );
  if (byKey?.id != null && String(byKey.id).trim() !== "") return String(byKey.id).trim();
  return slug;
}
